module.exports = __webpack_public_path__ + "static/media/recovery-color2.de5ce456.png";